import axios, { AxiosPromise } from 'axios';
import { api } from '../config/Master';
import { MixpanelTrackEvent } from '../utils/mixpanel';

const mixpanelTrack = (formData: any): AxiosPromise => {
  return axios({
    method: 'POST',
    url: `${api}/mixpanel/track`,
    data: formData,
  });
};

const mixpanelTrackEvent = (formData: MixpanelTrackEvent): AxiosPromise => {
  return axios({
    method: 'POST',
    url: `${api}/mixpanel/track-event`,
    data: formData,
  });
};

const mixpanelTrackEventAnonymously = (formData: MixpanelTrackEvent): AxiosPromise => {
  return axios({
    method: 'POST',
    url: `${api}/mixpanel/track-event-anonymously`,
    data: formData,
  });
};

export { mixpanelTrack, mixpanelTrackEvent, mixpanelTrackEventAnonymously };
